// eg. given,
//  "urls": {
//     "100": "https://photo_url_1",
//     "1800": "https://photo_url_2"
// }
// returns https://photo_url_2
export const getPhotoWithMaxDimension = (photoUrlHash) => {
  const key = Object.keys(photoUrlHash).reduce((a, b) => (a > b ? a : b));
  return photoUrlHash[key];
};

// plus 10 entries and then round up to nearest 10
export const roundUpNearest10 = (num) => {
  const n = num < 1 ? 10 : num + 10;
  return Math.ceil(n / 10) * 10;
};

export default {
  getPhotoWithMaxDimension
};
